import {
  Component,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
  EventEmitter,
} from '@angular/core';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { MultiSelectComponent } from '../../atoms/multi-select/multi-select.component';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-country-selector',
  templateUrl: './country-selector.component.html',
  styleUrls: ['./country-selector.component.scss'],
})

/**
 * Country Selector Component
 */
export class CountrySelectorComponent {
  @ViewChild(MultiSelectComponent) multiSelector!: MultiSelectComponent;

  @Input() isMultiSelect = true;

  _countries: any[] = [];

  _selected_countries: any[] = [];

  _selected_values: string[] = [];

  /**
   * set method for countries Input
   * @param {any[]} newValue
   */
  @Input()
  set countries(newValue: any[]) {
    this._countries = [];
    for (const country of newValue) {
      if (country['initials']) {
        this._countries.push({
          label: country['name'],
          value: country['id'],
        });
      }
    }
    this._selected_countries = this._countries;

    this._selected_values =
      this._selected_countries?.map((data) => data.value) ?? [];
  }

  /**
   * Get method for countries input
   */
  get countries(): any[] {
    return this._countries;
  }

  @Output() valueChange = new EventEmitter<string[]>();

  /**
   * Detect changes on fields
   * @param {SimpleChanges} changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['countries']) {
      const vals = this._selected_countries;
      if (this.multiSelector) {
        this.multiSelector.updateSelectedValues(vals);
      } else {
        Promise.resolve().then(() =>
          this.multiSelector?.updateSelectedValues(vals)
        );
      }
      this.valueChange.emit(this._selected_values);
    }
  }

  /**
   * Class constructor
   * @param {AuthenticatedUserService} authenticatedUserService
   */
  constructor(private authenticatedUserService: AuthenticatedUserService) {}

  /**
   * Event called when a country is selected or disselected
   * @param {any} selectedValues
   */
  handleCountryChange(selectedValues: string[]): void {
    if (selectedValues instanceof MatSelectChange) {
      selectedValues = selectedValues.value;
    }
    this._selected_values = selectedValues ?? [];
  }

  /**
   * Event called when the country multi-select is closed and the selection changed.
   * @param {string[]} selectedValues - The currently selected option values.
   * @return {void}
   */
  handleMultiSelectClosedWithChanges(selectedValues: string[]): void {
    this._selected_values = selectedValues ?? [];
    this.valueChange.emit(selectedValues);
  }
}
